import { create } from "zustand";

export const darwinApilocalStorageKey = "darwin-api-url";
export const darwinLegacyUrlLocalStorageKey = "darwin-legacy-url";

export const getUrlWithoutTrailingSlash = (url: string) => {
  return url.endsWith("/") ? url.slice(0, -1) : url;
};

export const getDarwinApiUrlFromLocalStorage = () => {
  const darwinLegacyUrl =
    typeof localStorage !== "undefined"
      ? localStorage?.getItem(darwinLegacyUrlLocalStorageKey)
      : null;

  const darwinApiUrl =
    typeof localStorage !== "undefined" ? localStorage?.getItem(darwinApilocalStorageKey) : null;

  const urls = {
    darwinLegacyUrl: "",
    darwinApiUrl: "",
    darwinGraphqlApiUrl: "",
  };

  if (darwinApiUrl) {
    const parsedDarwinUrl = getUrlWithoutTrailingSlash(darwinApiUrl);
    const graphqlApiUrl = `${parsedDarwinUrl}/graphql`;

    urls.darwinApiUrl = parsedDarwinUrl;
    urls.darwinGraphqlApiUrl = graphqlApiUrl;
  }

  if (darwinLegacyUrl) {
    urls.darwinLegacyUrl = getUrlWithoutTrailingSlash(darwinLegacyUrl);
  }

  return {
    ...urls,
    /**
     * Fallback for non multitenant contexts
     * We use the darwinApiUrl as fallback for the darwinLegacyUrl
     * Because the darwinLegacyUrl is only available in multitenant contexts
     */
    darwinLegacyUrl: !urls?.darwinLegacyUrl ? urls?.darwinApiUrl : urls?.darwinLegacyUrl,
  };
};

type State = {
  darwinLegacyUrl: string;
  darwinApiUrl: string;
  darwinGraphqlApiUrl: string;
};

export const usePublicConfigStore = create<State>(() => ({
  darwinLegacyUrl: getDarwinApiUrlFromLocalStorage().darwinLegacyUrl,
  darwinApiUrl: getDarwinApiUrlFromLocalStorage().darwinApiUrl,
  darwinGraphqlApiUrl: getDarwinApiUrlFromLocalStorage().darwinGraphqlApiUrl,
}));

export const setDarwinApiUrl = (darwinApiUrl: null | string) => {
  const parsedDarwinUrl = darwinApiUrl ? getUrlWithoutTrailingSlash(darwinApiUrl) : null;

  if (typeof localStorage !== "undefined") {
    if (darwinApiUrl) {
      localStorage?.setItem(darwinApilocalStorageKey, parsedDarwinUrl);
    } else {
      localStorage?.removeItem(darwinApilocalStorageKey);
    }
  }

  const { darwinApiUrl: savedApiUrl, darwinGraphqlApiUrl } = getDarwinApiUrlFromLocalStorage();

  usePublicConfigStore.setState({
    darwinApiUrl: savedApiUrl,
    darwinGraphqlApiUrl: darwinGraphqlApiUrl,
  });
};

export const setDarwinLegacyUrl = (darwinLegacyUrl: null | string) => {
  const parsedDarwinLegacyUrl = darwinLegacyUrl
    ? getUrlWithoutTrailingSlash(darwinLegacyUrl)
    : null;

  if (typeof localStorage !== "undefined") {
    if (darwinLegacyUrl) {
      localStorage?.setItem(darwinLegacyUrlLocalStorageKey, parsedDarwinLegacyUrl);
    } else {
      localStorage?.removeItem(darwinLegacyUrlLocalStorageKey);
    }
  }

  const { darwinLegacyUrl: savedLegacyUrl } = getDarwinApiUrlFromLocalStorage();

  usePublicConfigStore.setState({
    darwinLegacyUrl: savedLegacyUrl,
  });
};
